export const apiPath = '/v1/assets';
const actionType = 'ASSET_CONTROLS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
